import { HeaderAndLead } from "../../../react4xp/parts/h1-display-and-lead/h1-display-and-lead";

export default (props) => <HeaderAndLead {...props} />